// The candidate's CV, loaded inline inside the profile card. Embeds the resume
// with the shared ATS PDF viewer (PDFReaderBrowser — the same one the candidate
// Resume page uses) so the document renders in place rather than as a
// filename + Preview/Download row.

import { Box } from '@chakra-ui/react';
import { PDFReaderBrowser } from '@/components/file-viewers/reactPdf';
import type { ResumeSectionProps } from './ResumeSection.types';

// Fixed viewer height when not filling (carousel card).
const VIEWER_HEIGHT = 460;

export const ResumeSection = ({
  resumes,
  fill = false,
}: ResumeSectionProps) => {
  // Only the primary resume — the ATS lists the current one first.
  const primary = resumes.find((r) => r.url);
  if (!primary) return null;

  return (
    <Box
      overflow="hidden"
      // The shared PDF viewer rounds its own container; square it off when
      // filling so the top corners aren't rounded against the flush panel.
      sx={
        fill ? { '& [class*="rp-container"]': { borderRadius: 0 } } : undefined
      }
      data-test-id="agentforge-resume-section"
      {...(fill
        ? // Fill the panel and bleed full-width (cancel its 16px x-padding),
          // set off by a top rule instead of a boxed border.
          {
            flex: '1',
            minH: '480px',
            h: '100%',
            w: 'calc(100% + 32px)',
            mx: '-16px',
            borderTopWidth: '1px',
            borderTopStyle: 'solid',
            borderTopColor: 'border-color',
          }
        : {
            height: `${VIEWER_HEIGHT}px`,
            border: '1px solid',
            borderColor: 'border-color',
            borderRadius: '8px',
          })}
    >
      <PDFReaderBrowser
        file={primary.url}
        content_type={primary.contentType}
        preview_url=""
        fileName={primary.fileName}
        isCompact
      />
    </Box>
  );
};
